import Swiper, { Navigation, Pagination, EffectFade } from 'swiper'

Swiper.use([Navigation, Pagination, EffectFade])

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

function init() {
  const testimonialsCarousel = document.querySelector('[data-testimonials-slider]')

  if (!testimonialsCarousel) return

  const slides = Array.from(testimonialsCarousel.querySelectorAll('.TestimonialsCarousel-item'))
  const bulletsLabels = slides.map((slide, index, arr) => {
    const name = slide.querySelector('.Testimonial-name') ? slide.querySelector('.Testimonial-name').textContent.trim() : ''
    const age = slide.querySelector('.Testimonial-age') ? slide.querySelector('.Testimonial-age').textContent.trim() : ''
    const position = index + 1
    const total = arr.length

    return `${name} ${age} - Citation - affichée ${position} sur ${total}`
  })

  const testimonialsdropdown = testimonialsCarousel.querySelectorAll('[data-testimonial-dropdown]')

  const renderBullet = (index, className) => {
    const label = bulletsLabels[index] || `Citation affichée ${index + 1} sur ${bulletsLabels.length}`
    const isFirst = index === 0
    return `<button class="${className}" role="tab" tabindex="${isFirst ? '0' : '-1'}" aria-selected="${isFirst ? 'true' : 'false'}" aria-controls="testimonial-slide-${index + 1}" aria-label="${label}" title="${label}"></button>`
  }

  let testimonialsCarouselOptions = {
    slidesPerView: 'auto',
    centeredSlides: true,
    pagination: {
      el: '.TestimonialsCarousel-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet
    }
  }

  if (Foundation.MediaQuery.atLeast('medium')) {
    testimonialsCarouselOptions = {
      slidesPerView: 'auto',
      loop: true,
      effect: 'fade',
      allowTouchMove: false,
      navigation: {
        nextEl: '.TestimonialsCarousel-nav--next',
        prevEl: '.TestimonialsCarousel-nav--previous',
      },
      a11y: {
        prevSlideMessage: 'Citation précédente',
        nextSlideMessage: 'Citation suivante',
      },
      pagination: {
        el: '.TestimonialsCarousel-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet
      }
    }
  }

  const testimonialsCarouselInit = new Swiper(testimonialsCarousel, testimonialsCarouselOptions)

  const paginationContainer = testimonialsCarousel.querySelector('.TestimonialsCarousel-pagination')
  if (paginationContainer) {
    paginationContainer.setAttribute('role', 'tablist')
  }

  testimonialsCarousel.querySelectorAll('.swiper-slide-duplicate').forEach(slide => {
    slide.setAttribute('aria-hidden', 'true')
    slide.setAttribute('tabindex', '-1')
    slide.removeAttribute('role')
    slide.removeAttribute('id')
  })

  testimonialsCarousel.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').forEach(slide => {
    slide.setAttribute('role', 'tabpanel')
  })

  function updateAriaStates(realIndex) {
    testimonialsCarousel.querySelectorAll('.TestimonialsCarousel-pagination .swiper-pagination-bullet').forEach((bullet, i) => {
      const active = i === realIndex
      bullet.setAttribute('tabindex', active ? '0' : '-1')
      bullet.setAttribute('aria-selected', active ? 'true' : 'false')
    })
    Array.from(testimonialsCarousel.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).forEach((slide, i) => {
      const active = i === realIndex
      slide.setAttribute('tabindex', active ? '0' : '-1')
      slide.setAttribute('aria-hidden', active ? 'false' : 'true')
    })
  }

  updateAriaStates(0)

  testimonialsCarouselInit.on('slideChange', () => {
    updateAriaStates(testimonialsCarouselInit.realIndex)
    testimonialsdropdown.forEach(testimonial => {
      if (testimonial.classList.contains('Testimonial-dropdown--open')) {
        testimonial.classList.remove('Testimonial-dropdown--open')
        testimonial.querySelector('.Testimonial-moreButton').setAttribute('aria-label', 'Lire la suite')
      }
    })
  })
}
